module.exports = __webpack_public_path__ + "img/icon_breathe.897d67c2.png";